function timeAgoEST(timestamp) {
  // Helper: get Date object in Eastern Time
  function toEasternTime(date) {
    // Convert the given UTC or local time to EST/EDT
    const options = { timeZone: "America/New_York" };
    const formatter = new Intl.DateTimeFormat("en-US", {
      ...options,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
    const parts = formatter.formatToParts(date);
    const get = (type) => parts.find((p) => p.type === type).value;
    return new Date(
      `${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get(
        "minute"
      )}:${get("second")}`
    );
  }

  const nowEST = toEasternTime(new Date());
  const pastEST = toEasternTime(new Date(timestamp));

  const diffMs = nowEST - pastEST;
  const diffMinutes = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMinutes < 1) {
    return "Just now";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
  } else {
    return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
  }
}

export default timeAgoEST;
